import React, { useState, useEffect } from 'react';
import ProfileDropdown from './ProfileDropdown';
import Logo from './Logo';
import { useAuth } from '../contexts/AuthContext';
import { getUserDetails } from '../lib/api/userApi';

/**
 * Header component for the application
 * 
 * @param {boolean} sidebarCollapsed - Whether the sidebar is collapsed
 * @param {function} toggleSidebar - Function to toggle sidebar collapsed state
 */
const Header = ({ 
  sidebarCollapsed, 
  toggleSidebar
}) => {
  const { user } = useAuth();
  const [userDetails, setUserDetails] = useState({
    firstName: '',
    lastName: '',
    preferredName: ''
  });
  
  // Fetch user details when component mounts
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const { data, error } = await getUserDetails();
        if (error) {
          console.error('Error fetching user details:', error);
          return;
        }
        
        if (data) {
          setUserDetails({
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            preferredName: data.preferredName || ''
          });
        }
      } catch (err) {
        console.error('Error in user details fetch:', err);
      }
    };
    
    if (user) {
      fetchUserDetails();
    }
  }, [user]);
  
  // Default logo fallback for development
  const logoFallback = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Ccircle cx='20' cy='20' r='18' fill='%23C0E1F7' stroke='%230A84FF' stroke-width='2'/%3E%3Cpath d='M15 15 Q20 10, 25 15 Q30 20, 25 25 Q20 30, 15 25 Q10 20, 15 15' fill='%230A84FF'/%3E%3Ccircle cx='17' cy='17' r='2' fill='white'/%3E%3Ccircle cx='23' cy='17' r='2' fill='white'/%3E%3C/svg%3E";
  
  // Get user email or use placeholder
  const userEmail = user?.email || 'user@example.com';
  // Get username from email (remove @domain.com) or use placeholder
  const userName = userEmail ? userEmail.split('@')[0] : 'User';
  
  return (
    <header className="bg-white p-4 flex justify-between items-center h-[64px]">
      <div className="flex items-center">
        <Logo size={40} textSize="text-xl" />
      </div>
      
      <ProfileDropdown 
        userName={userName} 
        userEmail={userEmail} 
        userDetails={userDetails}
      />
    </header>
  );
};

export default Header; 